import { z } from 'zod';
export const awsConfigSchema = z.object({
    awsRegion: z.string(),
    awsAccessKey: z.string(),
    awsSecretKey: z.string(),
});
export const getBoardParamsSchema = z.object({
    boardName: z.string({ description: 'Board name e.g. GAPD' }),
});
export const responseBoardSchema = z.discriminatedUnion('Status', [
    z.object({
        Status: z.literal('OK'),
        boardUsage: z.number().optional(),
        ObtainmentMethod: z.string(),
        DataUpdated: z.string().optional(),
        RecordCount: z.number().optional(),
        IntegrationType: z.enum(['Datafile', 'Passthru']),
    }),
    z.object({ Status: z.literal('FAILED'), Message: z.string() }),
]);
